import { Scatter } from "react-chartjs-2";
import { Chart as ChartJS } from 'chart.js';

const Construct_code_category = [
  { construct: "Self-Efficacy", code: "se", category: "Student Beliefs" },
  { construct: "Cognitive Engagement", code: "cog", category: "Learning Behaviors" },
  { construct: "Behavioral Engagement", code: "beh", category: "Learning Behaviors" },
  { construct: "Affective Engagement", code: "aff", category: "Learning Behaviors" },
  { construct: "Autonomy", code: "aut", category: "Classroom Context" },
  { construct: "Relatedness", code: "rel", category: "Classroom Context" },
  { construct: "Value", code: "val", category: "Student Beliefs" },
  { construct: "Self-Regulation", code: "srt", category: "Learning Behaviors" },
  { construct: "Intrinsic Motivation", code: "amot", category: "Student Beliefs" }, // or autonomous motivation? 
  { construct: "Extrinsic Motivation", code: "cmot", category: "Student Beliefs" }, // or controlled motivation?
  { construct: "Academic Burden", code: "bur", category: "Student Beliefs" },
  { construct: "Belongingness", code: "bel", category: "Classroom Context" }, // or perceived belonging?
  { construct: "Cultural Congruity", code: "cult", category: "Classroom Context" },
  { construct: "Withdrawal Intention", code: "with", category: "Learning Behaviors" },
];

const likertLabels = {
  1: "Strongly Disagree",
  2: "Disagree",
  3: "Slightly Disagree",
  4: "Slightly Agree",
  5: "Agree",
  6: "Strongly Agree"
};


const codeLabelMap = Construct_code_category.reduce((acc, item) => {
    acc[item.code] = item.construct;
    return acc;
}, {});

export default function ScatterChart({ individual, avg, xKey, yKey }) {
    console.log("ScatterChart individual & avg:", individual, avg);
    const chartData = {
        datasets: [
            // Main scatter points
            {   
                type: 'scatter',
                label: `${xKey} vs ${yKey}`,
                data: individual.map(d => ({
                    x: d[xKey],
                    y: d[yKey],
                    label: d.name
                })),
                backgroundColor: 'rgba(211, 30, 30, 0.6)',
                pointRadius: 5,
                pointHoverRadius: 7,
            },
            ...(avg && avg[xKey] && avg[yKey] ? [
                // Verticle line for class mean
                {
                    type: 'line',
                    data: [{ x: avg[xKey], y: 0.8 }, { x: avg[xKey], y: 6.2 }],
                    borderColor: 'rgba(158, 7, 7, 0.8)',
                    borderWidth: 2,
                    pointRadius: 0,
                    //borderDash: [5, 5],
                },

                // Horizontal line for class mean
                {
                    type: 'line',
                    data: [{ x: 0.95, y: avg[yKey] }, { x: 6.05, y: avg[yKey] }],
                    borderColor: 'rgba(158, 7, 7, 0.8)',
                    borderWidth: 2,
                    pointRadius: 0,
                    // borderDash: [5, 5],
                },
            ] : []),
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                callbacks: {
                    label: (ctx) => {
                        const x = ctx.raw.x;
                        const y = ctx.raw.y;
                        const name = ctx.raw.label;
                        const xLabel = codeLabelMap[xKey];
                        const yLabel = codeLabelMap[yKey];

                        return [
                            `${name}`,
                            `${xLabel}: ${x}`,
                            `${yLabel}: ${y}`
                        ];
                    }
                }
            },
            legend: {
                display: false,
            },
        },
        scales: {
            x: {
                type: 'linear',
                position: 'bottom',
                title: {
                    display: true,
                    text: codeLabelMap[xKey]
                },
                min: 0.95,
                max: 6.0,
                ticks: {
                    callbacks: (v) => likertLabels[v] 
                }
            },
            y: {
                title: {
                    display: true,
                    text: codeLabelMap[yKey]
                },
                min: 0.8,
                max: 6.2,
                // ticks: {
                //     callbacks: (v) => likertLabels[v] 
                // }
                ticks: {
                    callback: (v) => {
                        return Number.isInteger(v) && v >= 1 && v <= 6 ? likertLabels[v] ?? v : '';
                    },
                }
            }
        }
    };
    return <Scatter data={chartData} options={options} />;
}